// AGB.jsx
import React from 'react'
import { Helmet } from 'react-helmet-async'

function AGB() {
  return (
    <>
      <Helmet>
        <title>AGB | Payroll Experten</title>
        <meta name="description" content="Allgemeine Geschäftsbedingungen von Payroll Experten. Transparente und faire Bedingungen für unsere Lohnabrechnungsdienstleistungen." />
      </Helmet>
      <div className="min-h-screen bg-gray-50 py-20 px-6">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-12 border border-gray-200">
        <h1 className="text-4xl font-black text-gray-900 mb-12 text-center border-b-4 border-yellow-600 pb-8">
          Allgemeine Geschäftsbedingungen
        </h1>
        
        <div className="space-y-8 text-lg leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold text-yellow-900 mb-4">1. Vertragsgegenstand</h2>
            <p className="p-6 bg-gray-50 rounded-xl">
              Gegenstand ist die Erstellung von Lohn- und Gehaltsabrechnungen nach den vom Kunden 
              zur Verfügung gestellten Unterlagen. Die Dienstleisterin haftet nicht für Fehler in den 
              Eingabedaten.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-900 mb-4">2. Vergütung</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="p-6 bg-blue-50 rounded-xl">
                <p><strong>Satz:</strong> 12-17€ pro Abrechnung (Staffel)</p>
                <p><strong>Zahlung:</strong> Monatlich netto per Überweisung</p>
              </div>
              <div className="p-6 bg-green-50 rounded-xl">
                <p><strong>Fälligkeit:</strong> 10. des Folgemonats</p>
                <p><strong>Mahnung:</strong> 2% p.a. + Mahngebühren</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-900 mb-4">3. Leistungszeitraum</h2>
            <p className="p-6 bg-indigo-50 rounded-xl">
              Abrechnungen nach Eingang vollständiger Daten.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-900 mb-4">4. Haftung</h2>
            <p className="p-6 bg-red-50 border-l-4 border-red-400 rounded-xl">
              Haftung beschränkt auf grobe Fahrlässigkeit und Vorsatz. 
              Maximaler Schadensersatz: Monatsvergütung.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-yellow-900 mb-4">5. Kündigung</h2>
            <p className="p-6 bg-purple-50 rounded-xl">
              Ordentliche Kündigung: 2 Monate zum Monatsende.<br />
              Außerordentlich: jederzeit bei wichtigem Grund.
            </p>
          </section>

          <section className="pt-8 border-t border-gray-200">
            <p className="text-center text-sm text-gray-600 p-8 bg-gray-50 rounded-2xl">
              Stand: Januar 2026. Änderungen vorbehalten.
            </p>
          </section>
        </div>
      </div>
      </div>
    </>
  )
}

export default AGB
